/**
 * JCTCTAS-152: standalone Vite entry for modules/hero-video-viewport.js --
 * split out of common.js so it only ever downloads on a page that actually
 * has a JCTC Hero block (see inc/scripts.php's jctc_block_conditional_assets()).
 * Module scripts execute after the document has been parsed (same timing as
 * a classic `defer` script), so no `$(document).ready()`/extra readiness
 * wrapper is needed here -- see membership-qr.js/consent-banner-style.js for
 * the same existing convention on this theme's other standalone entries.
 */
import initHeroVideoViewport from '../modules/hero-video-viewport.js';

document.addEventListener('DOMContentLoaded', initHeroVideoViewport);
